var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfileGreen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#04ba6f",
  d: "M0 25v-3.125c0-3.438 5.625-6.251 12.5-6.251S25 18.437 25 21.875V25zM6.249 6.251A6.25 6.25 0 1 1 12.5 12.5a6.25 6.25 0 0 1-6.251-6.249"
})));
export { SvgProfileGreen as ReactComponent };
export default __webpack_public_path__ + "static/media/profile_green.a525a6c3.svg";